import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec5ac558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row p-4 m-lg-0 justify-content-center bg-white rounded-4 shadow" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_7 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-1 col-form-label" }, null, -1))
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-8 col-form-label" }
const _hoisted_10 = { class: "col-lg-10 d-flex margin-target" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_12 = {
  key: 1,
  class: "col-lg-12"
}
const _hoisted_13 = {
  key: 2,
  class: "col-lg-12"
}
const _hoisted_14 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_15 = { class: "w-max-content col-lg-2 col-form-label margin-label" }
const _hoisted_16 = { class: "w-max-content col-lg-1 col-form-label margin-status" }
const _hoisted_17 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_18 = { class: "col-lg-10" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_22 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_23 = { class: "w-max-content col-lg-1 col-form-label margin-content" }
const _hoisted_24 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_25 = { class: "mt-2" }
const _hoisted_26 = { class: "col-lg-10" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_30 = { class: "w-max-content col-form-label" }
const _hoisted_31 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_32 = { class: "w-max-content col-lg-2 col-form-label margin-label" }
const _hoisted_33 = { class: "w-max-content col-lg-1 col-form-label margin-status" }
const _hoisted_34 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_35 = { class: "px-2 d-flex" }
const _hoisted_36 = { class: "input-group mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "ms-3 mt-2" }
const _hoisted_41 = ["value"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "ms-3 mt-2" }
const _hoisted_44 = { class: "row col-lg-12 px-2 px-lg-0" }
const _hoisted_45 = { class: "row mx-lg-0 px-lg-0 pb-2 pb-lg-4 gx-3 mb-2 mb-lg-4" }
const _hoisted_46 = { class: "w-max-content col-lg-2 col-form-label margin-label" }
const _hoisted_47 = { class: "w-max-content col-lg-1 col-form-label margin-status" }
const _hoisted_48 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_49 = { class: "px-2 d-flex" }
const _hoisted_50 = { class: "input-group mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_52 = ["value"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "ms-3 mt-2" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "ms-3 mt-2" }
const _hoisted_58 = { class: "row col-lg-12 px-2 px-lg-0" }
const _hoisted_59 = { class: "d-flex justify-content-center" }
const _hoisted_60 = {
  class: "modal fade",
  id: "editNotificationSuccess",
  tabindex: "-1",
  "aria-labelledby": "editNotificationSuccess",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "createNotificationSuccess"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_66 = { class: "text-center mt-3" }
const _hoisted_67 = { class: "modal-footer d-flex justify-content-center" }

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import flatPickr from 'vue-flatpickr-component'
import { Japanese } from 'flatpickr/dist/l10n/ja.js'

//validate
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { DEFAULT_MAX_LENGTH_TEXTAREA, DEFAULT_MIN_LENGTH } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import notificationServices from '@/services/community-managers.services'
import { debounce, range } from 'lodash'
import commonService from '@/services/common.service'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, ref, nextTick } from 'vue'
import dayjs from 'dayjs'
import { Modal } from 'bootstrap'
import ConfirmNotificationModal from '@/views/community-admin/notification-community/components/ConfirmNotificationModal.vue'
import { ConvertFromUTCTime } from '@/constants/datepicker'
import { countCharInSurrogatePair, customMaxLength, customMinLength, scrollToErrors } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')
dayjs.extend(isSameOrAfter)
const route = useRoute()
const router = useRouter()
const createFailed = ref(false)
const loading = ref<boolean>(false)
const ngKeyTitle = ref<boolean>(false)
const disabledButton = ref(false)

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route?.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('configuration'),
    to: '',
    active: false,
  },
  {
    content: translate('CF10title'),
    // 2022/10/12 VietNC sort CF10 UAT#4425(Ph2-R20221021)
    to: `/community/communities/${route?.params?.id}/notifications?publication_start_period=desc`,
    active: false,
  },
  {
    content: translate('CF20titleEditANotice'),
    to: '',
    active: true,
  },
]
const configDate = {
  locale: Japanese,
  wrap: true,
  disableMobile: true,
  minDate: '2022-01-01',
  dateFormat: 'Y/m/d',
}
onMounted(async () => {
  loading.value = true
  try {
    if (route.params?.id && route.params?.notification_id) {
      const res = await notificationServices.getNotificationById(route.params?.id, route.params?.notification_id)
      if (res.data?.success) {
        if (res.data.data.target === 'employee') formData.value.target = 2
        else if (res.data.data.target === 'alumni') formData.value.target = 3
        else formData.value.target = 4
        formData.value.title = res.data.data.title
        formData.value.content = res.data.data.content
        formData.value.hourStart = parseInt(dayjs(res.data.data.publication_start_period).format('HH'))
        formData.value.hourEnd = parseInt(dayjs(res.data.data.publication_end_period).format('HH'))
        formData.value.minutesStart = parseInt(dayjs(res.data.data.publication_start_period).format('mm'))
        formData.value.minutesEnd = parseInt(dayjs(res.data.data.publication_end_period).format('mm'))
        formData.value.publication_start_period = dayjs(res.data.data.publication_start_period).format('YYYY/MM/DD')
        formData.value.publication_end_period = dayjs(res.data.data.publication_end_period).format('YYYY/MM/DD')
      }
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
})

const rules = computed(() => {
  return {
    target: {
      required,
    },
    title: {
      required,
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 30),
    },
    content: {
      required,
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_LENGTH_TEXTAREA),
    },
    publication_start_period: {
      requiredSelect: function (value) {
        if (value) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= '2022-01-01') return true
      },
    },
    publication_end_period: {
      requiredSelect: function (value) {
        if (value) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= '2022-01-01') return true
      },
      afterStartDateHour: function (_value) {
        const start = buildDateTime(formData.value.publication_start_period, formData.value.hourStart, formData.value.minutesStart)
        const end = buildDateTime(formData.value.publication_end_period, formData.value.hourEnd, formData.value.minutesEnd)

        if (!start || !end) return true

        return end.isSameOrAfter(start)
      },
    },
    hourStart: {
      required,
    },
    hourEnd: {
      required,
    },
    minutesStart: {
      required,
    },
    minutesEnd: {
      required,
    },
  }
})

const formData = ref({
  target: 3,
  title: '',
  content: '',
  publication_start_period: dayjs(new Date()).format('YYYY-MM-DD'),
  publication_end_period: dayjs(new Date()).format('YYYY-MM-DD'),
  hourStart: 0,
  minutesStart: 0,
  hourEnd: 0,
  minutesEnd: 0,
})
const isCheckedNGKeyTitle = { value: false }
const v$ = useVuelidate(rules, formData)
const checkNGTitle = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.title.$model })
  ngKeyTitle.value = data.data?.data?.has_ngword
  isCheckedNGKeyTitle.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

const formDataSubmit = ref()
const onSubmit = async (): Promise<void> => {
  v$.value.$touch()

  isCheckedNGKeyTitle.value = false
  isCheckedNGContent.value = false
  await checkNGTitle()
  await checkNGContent()
  while (!isCheckedNGKeyTitle.value || !isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyTitle.value || ngKeyContent.value) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  let hourStartSubmit = formData.value.hourStart < 10 ? '0' + formData.value.hourStart : formData.value.hourStart
  let hourEndSubmit = formData.value.hourEnd < 10 ? '0' + formData.value.hourEnd : formData.value.hourEnd
  let minutesStartSubmit = formData.value.minutesStart < 10 ? '0' + formData.value.minutesStart : formData.value.minutesStart
  let minutesEndSubmit = formData.value.minutesEnd < 10 ? '0' + formData.value.minutesEnd : formData.value.minutesEnd
  formDataSubmit.value = {
    ...formData.value,
    publication_start_period: formData.value.publication_start_period + ' ' + hourStartSubmit + ':' + minutesStartSubmit,
    publication_end_period: formData.value.publication_end_period + ' ' + hourEndSubmit + ':' + minutesEndSubmit,
  }
  modalCreateConfirm.value.show()
}

const onSubmitMessage = async () => {
  disabledButton.value = true
  try {
    if (route.params?.id) {
      const data = {
        ...formDataSubmit.value,
        target: parseInt(formDataSubmit.value.target),
        publication_start_period: ConvertFromUTCTime(formDataSubmit.value.publication_start_period),
        publication_end_period: ConvertFromUTCTime(formDataSubmit.value.publication_end_period),
      }
      const response = await notificationServices.updateNotification(route.params?.id, route.params?.notification_id, data)
      modalCreateConfirm.value.hide()
      if (response?.status === 200) {
        createFailed.value = false
      } else {
        createFailed.value = true
      }
      modalCreateFinish.value.show()
    }
    setTimeout(() => {
      disabledButton.value = false
    }, 500)
  } catch (error) {
    console.log(error)
    modalCreateConfirm.value.hide()
    modalCreateFinish.value.show()
    createFailed.value = false
    disabledButton.value = false
  }
}
const modalCreateConfirm = ref()
const modalCreateFinish = ref()
onMounted(() => {
  modalCreateConfirm.value = new Modal(document.getElementById('confirmModal'))
  modalCreateFinish.value = new Modal(document.getElementById('editNotificationSuccess'))
})
const handleBack = (): void => {
  router.push(`/community/communities/${route.params.id}/notifications/${route.params?.notification_id}/edit`)
}
const handleBackList = (): void => {
  // 2022/10/12 VietNC sort CF10 UAT#4425(Ph2-R20221021)
  router.push(`/community/communities/${route.params.id}/notifications?publication_start_period=desc`)
}
const buildDateTime = (date, hour, minute) => {
  if (!date) return null

  return dayjs(date)
    .hour(Number(hour ?? 0))
    .minute(Number(minute ?? 0))
    .second(0)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CF20titleEditANotice')), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('CF20targetPerson')), 1),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (formData.value.target == 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('almunai')), 1))
                    : (formData.value.target == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('CF20enroll')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('CF20adminUser')), 1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('OE65content')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "title",
                    class: _normalizeClass(['form-control', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGTitle) && _unref(checkNGTitle)(...args)))
                  }, null, 42, _hoisted_19), [
                    [
                      _vModelText,
                      _unref(v$).title.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyTitle.value && !_unref(v$).title.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('title'),
                    params: [_unref(DEFAULT_MIN_LENGTH), 30],
                    validator: _unref(v$).title.$errors[0]?.$validator
                  }, null, 8, ["title", "params", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createTextVNode(_toDisplayString(_unref(translate)('content')), 1),
                _createElementVNode("div", null, "（" + _toDisplayString(_unref(translate)('CF20maxContentCharacter')) + "）", 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(translate)('CF20numberOfCharacter')) + _toDisplayString(_unref(countCharInSurrogatePair)(formData.value.content)) + _toDisplayString(_unref(translate)('CF20letter')), 1),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("textarea", {
                    id: "content",
                    name: "content",
                    class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                    rows: "10",
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                  }, null, 42, _hoisted_27), [
                    [
                      _vModelText,
                      _unref(v$).content.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyContent.value && !_unref(v$).content.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('content'),
                    params: [_unref(DEFAULT_MIN_LENGTH), _unref(DEFAULT_MAX_LENGTH_TEXTAREA)],
                    validator: _unref(v$).content.$errors[0]?.$validator
                  }, null, 8, ["title", "params", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('CF20text')), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('CF20startDate')), 1),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_unref(flatPickr), {
                      modelValue: _unref(v$).publication_start_period.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).publication_start_period.$model) = $event)),
                      config: configDate,
                      class: _normalizeClass(['form-control bg-white', _unref(v$).publication_start_period.$error ? 'is-invalid' : ''])
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_37
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select mb-2 ms-3",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).hourStart.$model) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(range)(0, 24), (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, [
                        (item < 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, "0"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(item), 1)
                      ], 8, _hoisted_38))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(v$).hourStart.$model]
                  ]),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(translate)('CF20hour')), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select mb-2 ms-3",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).minutesStart.$model) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(range)(0, 60), (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, [
                        (item < 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, "0"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(item), 1)
                      ], 8, _hoisted_41))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(v$).minutesStart.$model]
                  ]),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(translate)('CF20minutes')), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", {
                    class: _normalizeClass([_unref(v$).publication_start_period.$error ? 'is-invalid' : ''])
                  }, null, 2),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)(`CF20startDate`),
                    params: [_unref(dayjs)(new Date()).format('YYYY'), _unref(dayjs)(new Date()).format('M'), _unref(dayjs)(new Date()).format('D')],
                    validator: _unref(v$).publication_start_period.$errors[0]?.$validator
                  }, null, 8, ["title", "params", "validator"])
                ]),
                _createElementVNode("p", null, _toDisplayString(_unref(translate)('CF20textDate')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(translate)('CF20endDate')), 1),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_unref(flatPickr), {
                      modelValue: _unref(v$).publication_end_period.$model,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(v$).publication_end_period.$model) = $event)),
                      config: configDate,
                      class: _normalizeClass(['form-control bg-white', _unref(v$).publication_end_period.$error ? 'is-invalid' : ''])
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_51
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select mb-2 ms-3",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).hourEnd.$model) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(range)(0, 24), (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, [
                        (item < 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, "0"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(item), 1)
                      ], 8, _hoisted_52))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(v$).hourEnd.$model]
                  ]),
                  _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(translate)('CF20hour')), 1),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select mb-2 ms-3",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).minutesEnd.$model) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(range)(0, 60), (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: item
                      }, [
                        (item < 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, "0"))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(item), 1)
                      ], 8, _hoisted_55))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _unref(v$).minutesEnd.$model]
                  ]),
                  _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(translate)('CF20minutes')), 1)
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                _unref(v$).publication_end_period.$error || _unref(v$).hourEnd.$error || _unref(v$).hourStart.$error || _unref(v$).minutesStart.$error || _unref(v$).minutesEnd.$error || _unref(v$).publication_start_period.$error
                  ? 'is-invalid'
                  : '',
              ])
                  }, null, 2),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)(`CF20endDate`),
                    params: [_unref(dayjs)(new Date()).format('YYYY'), _unref(dayjs)(new Date()).format('M'), _unref(dayjs)(new Date()).format('D')],
                    validator: _unref(v$).publication_end_period.$errors[0]?.$validator
                  }, null, 8, ["title", "params", "validator"])
                ]),
                _createElementVNode("p", null, _toDisplayString(_unref(translate)('CF20textEndDate')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(Button, {
                title: _unref(translate)('back'),
                type: 'secondary',
                onClick: handleBackList,
                className: 'fw-bold me-2'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                onClick: onSubmit,
                className: 'fw-bold',
                type: 'secondary'
              }, null, 8, ["title"])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmNotificationModal, {
      formData: formDataSubmit.value,
      onSubmitMessage: onSubmitMessage,
      disabledButton: disabledButton.value
    }, null, 8, ["formData", "disabledButton"]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("h5", _hoisted_64, _toDisplayString(_unref(translate)('CF20titleEditANotice')), 1),
            _hoisted_65
          ]),
          _createElementVNode("p", _hoisted_66, _toDisplayString(createFailed.value ? _unref(translate)('updateCompleteFail') : _unref(translate)('updateComplete')), 1),
          _createElementVNode("div", _hoisted_67, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold',
              onClick: handleBack
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})